<template>
  <el-dialog
    class="modal-modify-role"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
     custom-class="greater"
  >
    <div class="content" v-loading="isLoading">
      <el-form ref="configForm" label-position="right"  :model="formData">
        <!-- <el-form-item label="账号所属运营商:" >
          <el-select v-model="formData.platformKey" placeholder="请选择所属运营商"  style="width: 440px;">
            <el-option
              style="width: 440px;"
              v-for="item in platformList"
              :key="item.platformKey"
              :label="item.platformName"
              :value="item.platformKey"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="选择角色:">
          <label>
            <el-input disabled v-model="formData.roleName" placeholder="请选择相应角色"  style="width: 440px;"></el-input>
            <el-button @click="$_showSelectRole" class="select__btn">选择</el-button>
          </label>
          <span class="input-tips">*选中的角色对应其功能权限，单选。</span>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </div>

    <select-role
      v-if="modal.show === true && modal.template === 'select-role'"
      :title="modal.title"
      :presetList="presetList"
      :customList="customList"
      :bindRoleId="formData.bindRoleId"
      @submit="$_callback"
      @close="$_close"
    ></select-role>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectRole from "./modal-select-role";

export default {
  name: "modal-config-global",
  props: {
    title: { type: String, default: "" },
    systemId: { type: Number, default: 0 },
    platformDataList: { type: Array, default: [] }
  },
  data() {
    return {
      visible: false,
      isLoading: true,
      formData: {
        bindRoleId: 0,
        roleName: ""
      },
      platformList: [],
      presetList: [], // 预设角色
      customList: [], // 自定义角色
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      }
    };
  },
  // watch: {
  //   "formData.platformKey"(val, oldVal) {
  //     if (oldVal !== "") {
  //       this.formData.bindRoleId = 0;
  //       this.formData.roleName = "";
  //     }
  //   }
  // },
  methods: {
    // 关闭本组件发起的弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 选择角色弹窗回调
    $_callback(role) {
      this.formData.bindRoleId = role.rid;
      this.formData.roleName = role.roleName;
      this.$_close();
    },
    // 打开选择角色弹窗
    $_showSelectRole() {
      // if (this.formData.platformKey === "") {
      //   $MessageBox.alert({ content: "请先选择运营商" });
      //   return false;
      // }
      this.isLoading = true;
      // 先获取角色数据
      this.$service
        .post("getRolesBySystemId", {
          systemId: this.systemId,
          status: 1
        })
        .then(result => {
          if (result.$.checkResult(result, true)) {
            this.presetList = [...result.data.presetList];
            this.customList = [...result.data.customList];

            this.modal.title = "选择账号所属的角色";
            this.modal.template = "select-role";
            this.modal.show = true;
          }
          this.isLoading = false;
        });
    },
    // 保存
    $_submit() {
      if (this.formData.bindRoleId === 0) {
        $MessageBox.alert({ content: "请选择相应角色" });
        return false;
      }
      let {  bindRoleId, roleName } = this.formData;
      let platformDataList = [{ bindRoleId, roleName }];
      this.$emit("submit", { systemId: this.systemId, platformDataList });
    },
    // 关闭本弹窗
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  components: {
    SelectRole
  },
  async created() {
    let result = await this.$service.post("getPlatformList", {
      platformName: "",
      status: 1,
      pageNow: 1,
      pageSize: 999
    });
    if (result.$.checkResult(result, true)) {
      this.platformList = result.data.rows.concat([]);
    }
    this.isLoading = false;
    if (this.platformDataList.length > 0) {
      let { bindRoleId, roleName, platformKey } = this.platformDataList[0];
      this.formData.bindRoleId = bindRoleId;
      this.formData.roleName = roleName;
      this.formData.platformKey = platformKey;
    }
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  padding: {
    left: 30px;
    top: 20px;
  }
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
  }
  /deep/ .el-input {
    width: 440px;
  }
}
.select__btn {
  margin-left: 8px;
}
.input-tips{
  margin-left:10px;
}
</style>
